export default __webpack_public_path__ + "static/media/creditStatus.f72a35a7.svg";